'use client';

import { tsr } from '@/libs/ts-rest/ts-rest';
import { createJobSearchQueryOptions } from '@/modules/job/contracts';
import type { JobSearchQueryOptions } from '@/modules/job/contracts';

type TransformFn<TData> = (response: Parameters<NonNullable<JobSearchQueryOptions['select']>>[0]) => TData;

export function useJobSearchQuery<TData = unknown>(
	query: Record<string, unknown>,
	selectOrOptions?: Omit<JobSearchQueryOptions<TData>, 'queryData' | 'queryKey'> | TransformFn<TData>,
) {
	const base = createJobSearchQueryOptions(query);

	const options = typeof selectOrOptions === 'function'
		? { select: selectOrOptions }
		: selectOrOptions ?? {};

	return tsr.jobs.search.useQuery({
		...base,
		...options,
	} satisfies JobSearchQueryOptions<TData>);
}
